var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11413",
    transform: "translate(954 775)",
    fill: "#5e708d",
    stroke: "#707070",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 175",
    transform: "translate(-954 -775)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11414",
    fill: "none",
    d: "M954 775h24v24h-24z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    fill: "#5e708d",
    transform: "translate(954 775)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14997",
    d: "M4.95 22.5H3a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3.95a1.05 1.05 0 0 1-.85 1.05 1 1 0 0 1-1.15-1v-3H4v17h1a1 1 0 0 1 1 1.15 1.05 1.05 0 0 1-1.05.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11415",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(6.5 7)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14998",
    d: "m22.7 13.7-4.9-4.9a.95.95 0 0 0-1.4 0L14.2 11H7.5a1 1 0 0 0 0 2h4.7l-2 2H7.5a1 1 0 0 0 0 2H9v4.5a1 1 0 0 0 1 1h4.9a1 1 0 0 0 .7-.3l7.1-7.1a.95.95 0 0 0 0-1.4Zm-8.25 6.8H11v-3.45l3.2-3.2 3.45 3.45Zm4.6-4.6-3.45-3.45 1.5-1.55 3.5 3.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayNote);
export default __webpack_public_path__ + "static/media/Gray_note.7f9362050f225fe09ca0f850672cec9d.svg";
export { ForwardRef as ReactComponent };